var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { trimEnd } from 'lodash';
var cls = classNames('labelled-value');
export var LabelledValueDefaultProps = {
  gapUnits: 2,
  labelSuffix: ':',
  tag: 'span'
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-size: ", ";\n    display: inline;\n    padding: 0;\n    margin: 0;\n  "], ["\n    font-size: ", ";\n    display: inline;\n    padding: 0;\n    margin: 0;\n  "])), theme.FONT_SIZE(12))
});
var LabelStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    text-transform: uppercase;\n    color: ", ";\n  "], ["\n    text-transform: uppercase;\n    color: ", ";\n  "])), theme.COLOR('sub'))
});
var ValueStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-size: 1em;\n    display: inline-block;\n    padding-left: ", ";\n  "], ["\n    font-size: 1em;\n    display: inline-block;\n    padding-left: ", ";\n  "])), theme.UNIT(2))
});
// -------- Components -------->
var My = {
  Container: styled.span(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Label: styled.span(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Value: styled.b(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ValueStyles)
};
export var LabelledValue = function (props) {
  var className = props.className,
    children = props.children,
    value = props.value,
    label = props.label,
    tag = props.tag,
    labelSuffix = props.labelSuffix;
  return (
    // @ts-ignore
    React.createElement(My.Container, {
      as: tag,
      className: cls.name(className)
    }, React.createElement(My.Label, null, trimEnd(label, labelSuffix), labelSuffix), React.createElement(My.Value, null, value || children))
  );
};
LabelledValue.cls = cls;
LabelledValue.defaultProps = LabelledValueDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;